import { JobPostRecommended } from "@/features/job-post/recommended/job-post-recommended";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/jobs/recommended/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <JobPostRecommended />;
}
